export const transformImgSrc = (src: string) => {
  if (!src) return src;
  if (!src.startsWith("data:")) {
    src = `${process.env.REACT_APP_API_URL}/images/${src}`;
  }
  return src;
};

export default function Image({
  src,
  dontTransform,
  ...props
}: {
  src: string;
  dontTransform?: boolean;
} & React.ImgHTMLAttributes<HTMLImageElement>) {
  src = dontTransform ? src : transformImgSrc(src);

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img src={src} {...props} />;
}
